import { useQuery } from '@tanstack/react-query';
import { checkWhatsAppHealth } from '@/services/whatsapp.service';

/**
 * Verifica a saúde real do canal WhatsApp (probe à Meta via edge function).
 * Corre automaticamente ao montar (quando `enabled`) e expõe `refetch` para o
 * botão "Verificar". Não refaz em foco/reconnect para evitar chamadas à Meta
 * a cada troca de aba; o admin força com o botão.
 */
export function useWhatsAppHealth(enabled: boolean) {
  return useQuery({
    queryKey: ['whatsapp-health'],
    queryFn: () => checkWhatsAppHealth(),
    enabled,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
